<template>
  <div class="pt-5 md:p-5">
    <p>{{ $t('log_in_create_account_cancel_modal_title') }}</p>
  </div>
</template>
